import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "phone",
  "use": "phone-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"phone\"><path fill-rule=\"evenodd\" d=\"M23.128 1.154L18.253.029a1.125 1.125 0 00-1.287.653l-2.25 5.25c-.197.46-.066.996.322 1.314l2.841 2.325a17.387 17.387 0 01-8.308 8.308l-2.325-2.841a1.125 1.125 0 00-1.314-.322l-5.25 2.25c-.5.214-.775.756-.653 1.287l1.125 4.875c.117.507.569.872 1.096.872C14.254 24 24 14.272 24 2.25c0-.524-.362-.978-.872-1.096z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol